import {getCountryFromLocale, getLanguageFromLocale as getLocaleWithDefault} from '@wix/wix-events-commons-statics'
import {CommonState} from '../types/state'

export const getLocale = (state: CommonState) => getLocaleWithDefault(state.environment.locale)

export const getLanguage = (state: CommonState) => state.environment.language

export const getCountry = (state: CommonState) => getCountryFromLocale(state.environment.locale)

export const getMultilingual = (state: CommonState) => state.multilingual

export const getCurrentLanguage = (state: CommonState) => state.multilingual.currentLanguage

export const isPrimaryLanguage = (state: CommonState) => state.multilingual.isPrimaryLanguage

export const isEditor = (state: CommonState) => state.environment.editor

export const isSite = (state: CommonState) => state.environment.site

export const isPreview = (state: CommonState) => state.environment.preview

export const isHeadless = (state: CommonState) => state.environment.headless

export const hasHeadlessTYP = (state: CommonState) => isHeadless(state) && state.environment.hasHeadlessTYP

export const getBaseUrl = (state: CommonState) => state.environment.baseUrl

export const getHomePageUrl = (state: CommonState) => state.environment.homePageUrl

export const getEventListPageUrl = (state: CommonState) => state.environment.eventListPageUrl

export const getEventListPageRelativeUrl = (state: CommonState) => state.environment.eventListPageRelativeUrl

export const getSeo = (state: CommonState) => state.environment.seo

export const hasHeadlessOriginUrl = (state: CommonState) => isHeadless(state) && getHomePageUrl(state)

export const isFormViewState = (state: CommonState) => state.environment.formViewState
